import { StoreHour } from '../../stores/storage/stores.types'

export const matchWeekdayHours = (storeHours: StoreHour[]) => {
  const weekdays = storeHours.filter((x) => x.dayOfWeek !== 'Saturday' && x.dayOfWeek !== 'Sunday')
  const unique = [...new Set(weekdays?.map((x) => `${x.open} - ${x.close}`))].sort(
    (a, b) => a?.localeCompare(b),
  )
  return unique.length === 1 ? true : false
}
